
import * as types from '../mutation-types'
import Cookies from 'js-cookie'

export const state = {

    pagamentos: {},

    pagamento: {},

    pagamento_id : Cookies.get('pagamento_id'), //necessário para efetuar pagamento

    tipo_pag : Cookies.get('tipo_pag'),

    token_cartao: null, //se existir recarrega a página de pagamento

    bandsCardPagSeguro : {}

    // verifica se os dados do usuario estão prontos para submeter a compra
    // obs: só funciona após a aplicação da action validarUserProntoCompra
    // vForm: {
    //   boleto : false,
    //   cartao : false
    // }

}

// ---------------------------------------------------------------------------

export const getters = {

    bandsDebito : state => state.bandsCardPagSeguro.debito,
    bandsCredito : state => state.bandsCardPagSeguro.credito

}


/* ---------------------------------------------------------------------------
|
|
|
*/

export const actions = {

  // ---------------------------------------------------------------------------

  setTipoPag( { state , commit } ,{ tipo_pag }){
      commit(types.SET_TIPO_PAG, { tipo_pag })
  },

  // ---------------------------------------------------------------------------

  setTokenCartao( { commit } ,{ token }){
      commit(types.SET_TOKEN_CARTAO, { token })
  },

// ---------------------------------------------------------------------------

  getBandsCardPagSeguro({ state, dispatch, commit }){

      let total = state.pagamento.valor
      PagSeguroDirectPayment.getPaymentMethods({
              	amount: total,
              	success: function(response) {
                    commit(types.SET_BANDS_CARD_PAGSERURO,  {
                      bandsCardPagSeguro : {
                        debito: response.paymentMethods.ONLINE_DEBIT.options,
                        credito: response.paymentMethods.CREDIT_CARD.options
                      }
                    })
                    // console.log(response.paymentMethods.CREDIT_CARD.options);
              	},
              	error: function(response) {
                  dispatch('alert/erroAoCarregar', 'Paciente' ,{ root: true })
              	}
      })
  },

  // ---------------------------------------------------------------------------

  async getPagamentos({commit}){

    commit(types.SET_PAGAMENTOS, { pagamentos : {}})

    const { data } = await axios.get('/api/pagamentos-json')

    commit(types.SET_PAGAMENTOS, { pagamentos : data.pagamentos})

  },

  // --------------------------------------------------------------------------------

  setPagamento({ commit }, { pagamento }){
      commit(types.SET_PAGAMENTO,  { pagamento } )
  },

  // --------------------------------------------------------------------------------
  //Biblioteca de pagamento js PagBank
  loadPagBankScript() {
      return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js';
          script.onload = () => resolve(window.PagSeguro); // Assumindo que a SDK expõe um objeto global PagSeguro
          script.onerror = reject;
          document.head.appendChild(script);
      }).then(() => {
                            console.log('PagBank SDK carregado!');
                            // console.log(window.PagSeguro);
                            // Agora você pode usar window.PagSeguro ou apenas PagSeguro
                        })
                        .catch(error => {
                            console.error('Falha ao carregar o SDK do PagSeguro:', error);
                        });
  },

}

/*
|-----------------------------------------------------------------------------
|
|
*/

export const mutations = {

    [types.SET_BANDS_CARD_PAGSERURO](state, { bandsCardPagSeguro } ){
        state.bandsCardPagSeguro = bandsCardPagSeguro
    },

    [types.SET_TIPO_PAG](state, { tipo_pag } ){
        state.tipo_pag = tipo_pag
        Cookies.set('tipo_pag', tipo_pag, { expires: null })
    },

    [types.SET_PAGAMENTO](state, { pagamento } ){
        state.pagamento = pagamento
        state.pagamento_id = pagamento.id
        if (pagamento.id) {
          Cookies.set('pagamento_id', pagamento.id, { expires: null })
        }else {
          Cookies.remove('pagamento_id')
        }
    },

    [types.SET_PAGAMENTOS](state, { pagamentos } ){
        state.pagamentos = pagamentos
    },

    [types.SET_TOKEN_CARTAO](state, { token }){
        state.token_cartao =  token
    },

    [types.SET_VALIDAR_FORM_PAG](state, { boleto, cartao }){
        state.vForm.boleto =  boleto
        state.vForm.cartao =  cartao
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/pagamentos.js